export const diaChiLayHang = {
  sections: {
    list: { title: 'Pickup addresses' },
    detail: { title: 'Pickup address' },
  },
  titles: { add: 'Add pickup address', edit: 'Edit pickup address' },
  columns: {
    chiNhanh: 'Branch',
    khoVatLy: 'Physical warehouse',
    phone: 'Phone',
    address: 'Address',
    province: 'Province/City',
    district: 'District',
    ward: 'Ward',
    viDo: 'Latitude',
    kinhDo: 'Longitude',
    viewLocation: 'Location',
    default: 'Default',
    note: 'Note',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    status: 'Status',
    onOffAction: 'On/Off',
  },
  filter: {
    searchPlaceholder: 'Search by address / phone / province...',
    textDetailTitle: 'Detail filters',
  },
  filters: {
    hintSection: 'Hint',
    hintBody:
      'Each project + branch has its own pickup address list, including one default address.',
    statusAll: 'All',
    defaultOnly: 'Default only',
    chiNhanhAll: 'All branches',
  },
  status: {
    dangHoatDong: 'Active',
    ngungHoatDong: 'Inactive',
  },
  actions: {
    pause: 'Deactivate',
    activate: 'Activate',
    viewLocation: 'View location',
    noLocation: 'No coordinates',
  },
  messages: {
    loadError: 'Could not load pickup addresses.',
    deleteSuccess: 'Pickup address deleted.',
    noData: 'No pickup addresses.',
    listSummary: '{count} item(s)',
    saveSuccess: 'Pickup address saved.',
    statusChanged: 'Status updated.',
    selectedCount: '{count} selected',
    deleteSelected: 'Delete selected ({count})',
    bulkDeleteConfirm: 'Delete {count} selected pickup address(es)?',
    bulkDeleteSuccess: 'Deleted {count} pickup address(es)',
    bulkDeletePartial: 'Deleted {ok}/{total}. {failed} could not be deleted.',
    bulkDeleteError: 'Bulk delete failed',
    bulkDeleteNoneSelected: 'No pickup addresses selected to delete',
  },
  form: {
    chiNhanh: 'Branch',
    dienThoai: 'Phone',
    diaChi: 'Address detail',
    tinhThanh: 'Province / City',
    phuongXa: 'Ward',
    viTriBanDo: 'Map location',
    chonTuBanDo: 'Pick on map',
    chonViTriTitle: 'Pick location on map',
    xacNhanViTri: 'Confirm location',
    viTriHienTai: 'Current location',
    xoaViTri: 'Clear location',
    viDo: 'Latitude',
    kinhDo: 'Longitude',
    banDoHuongDan: 'Click the map or drag the marker to pick a location.',
    banDoHuongDanNgan: 'No location yet. Click “Pick on map” to set coordinates.',
    coordsFormat: 'Lat: {viDo} · Lng: {kinhDo}',
    geoDenied:
      'Location permission denied. Please allow geolocation in the browser.',
    geoUnavailable: 'Unable to get current location.',
    reverseFailed:
      'Coordinates saved. Could not resolve the street address — please enter it manually.',
    macDinh: 'Set as default pickup address for this branch',
    ghiChu: 'Note',
  },
  validation: {
    chiNhanhRequired: 'Please select a branch.',
  },
  placeholders: {
    formTitle: 'Pickup address',
    formBody: '',
    provinceEmpty: '— Select Province/City —',
    wardEmpty: '— Select Ward —',
    addressSearch: 'Type at least 2 characters to search address',
    addressNoOptions: 'No address suggestions',
    viDo: 'e.g. 10.7769',
    kinhDo: 'e.g. 106.7009',
  },
  aria: {
    columnPicker: 'Choose visible columns',
  },
}
